import { PasswordDefinition } from '../../properties/baseTypes/Password';
import { stringTypeDefinition } from '../../properties/baseTypes/String';
import { urlTypeDefinition } from '../../properties/baseTypes/Url';
import { AddressDefinition } from '../../properties/baseTypes/Address';

import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

const ShopifyMultipassDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.ShopifyMultipass,
  // hasCustomUI allows it to be loaded on mobile
  hasCustomUI: true,
  friendlyName: 'Shopify Multipass',
  description: 'Shopify Multipass login for Lane Perks SSO',
  category: IntegrationCategoryEnum.Commerce,
  platforms: [PlatformEnum.Mobile, PlatformEnum.Web],
  type: IntegrationTypeEnum.Custom,
  settings: {
    name: {
      type: stringTypeDefinition.name,
      friendlyName: 'Name',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
    storeUrl: {
      friendlyName: 'Store URL',
      description: 'The URL of the Shopify store',
      type: urlTypeDefinition.name,
      editable: true,
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
    multipassSecret: {
      friendlyName: 'Multipass Secret',
      type: PasswordDefinition.name,
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
    adminApiPassword: {
      friendlyName: 'Admin API Password',
      type: PasswordDefinition.name,
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  },
  properties: {
    tags: {
      friendlyName: 'User Tags',
      type: stringTypeDefinition.name,
      validators: [
        {
          name: 'Required',
          value: false,
        },
      ],
    },
    address: {
      friendlyName: 'Address',
      type: AddressDefinition.name,
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  },
};

export const definition = ShopifyMultipassDefinition;
